import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

export default function ItemActionButtonExternalLink({url, text, icon}) {

    return (
        <Button variant="outlined" color="primary" fullWidth={true}
            onClick={() => window.location.href=url }>
            <Grid container direction="column" alignItems="center">
                {icon}
                <Typography color="primary">{text}</Typography>
            </Grid>
        </Button>
    );
}